import React, { useState, useEffect } from "react";
import OrgTree from "react-org-tree";
import "./FlowChart.css";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import DetailsSummary from "./DetailsSummary";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import CountUp from "react-countup";
import img1 from '../../../assets/img/data-analysis-icon.png'
import img2 from '../../../assets/img/chart-arrow-up-icon.png'
import img3 from '../../../assets/img/hand-money-income-dollar-icon.png'
import img4 from '../../../assets/img/quality-control-icon.png'
import img5 from '../../../assets/img/lamp-icon.png'
import { FaMinus } from "react-icons/fa";
import TotalValue from '../../data/TotalData.json'

const FlowChart = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get('name');
  const getCategoryNameData = TotalValue && TotalValue.filter((item) => item.PrimaryType === name)

  const TotalValueData = getCategoryNameData && getCategoryNameData
  .filter(item => item.PrimaryType === "Improve Margin")
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);


  const totalRecommandationsMargin = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.PrimaryType === "Improve Margin").length
  : 0;

  const TotalValueDataRevnuew = getCategoryNameData && getCategoryNameData
  .filter(item => item.SecondaryType === "Operational Initiatives")
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

  const TotalValueDataRevnuewLength = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.SecondaryType === "Operational Initiatives").length
  : 0;

  const TotalValueDataCostSaving = getCategoryNameData && getCategoryNameData
  .filter(item => item.SecondaryType === "Cost Saving")
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

  const TotalValueCostSavingLength = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.SecondaryType === "Cost Saving").length
  : 0;

  const TotalValueDataOverHead = getCategoryNameData && getCategoryNameData
  .filter(item => item.SecondaryType === "Overhead Control")
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

  const TotalValueOverHeadLength = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.SecondaryType === "Overhead Control").length
  : 0;

  const TotalValueDataOther= getCategoryNameData && getCategoryNameData
  .filter(item => item.SecondaryType === "Other")
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

  const TotalValueOverOther = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.SecondaryType === "Other").length
  : 0;



 const TotalValueDataImproveCashFlow = getCategoryNameData && getCategoryNameData
 .filter(item => item.PrimaryType === "Cash Improvement")
 .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

 const totalRecommandationsMarginCaseFlow = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.PrimaryType === "Cash Improvement").length
  : 0;

 const TotalValueDataAccountsReceivable
 = getCategoryNameData && getCategoryNameData
  .filter(item => item.SecondaryType === "Accounts Receivable")
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

  const TotalValueDataAccountsReceivableLength = getCategoryNameData && Array.isArray(getCategoryNameData)
  ? getCategoryNameData.filter(item => item.SecondaryType === "Accounts Receivable").length
  : 0;

  const TotalValueDataAccountsPayable
  = getCategoryNameData && getCategoryNameData
   .filter(item => item.SecondaryType === "Accounts Payable")
   .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);
 
   const TotalValueDataAccountsPayableLength = getCategoryNameData && Array.isArray(getCategoryNameData)
   ? getCategoryNameData.filter(item => item.SecondaryType === "Accounts Payable").length
   : 0;

   const TotalValueInventory
   = getCategoryNameData && getCategoryNameData
    .filter(item => item.SecondaryType === "Inventory")
    .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);
  
    const TotalValueInventorydLength = getCategoryNameData && Array.isArray(getCategoryNameData)
    ? getCategoryNameData.filter(item => item.SecondaryType === "Inventory").length
    : 0;

  const ImproveMargins =

  {
    id: 0,
    label: "Improve  Margins",
    dec: `$ ${(TotalValueData).toFixed(1)} Mn`,
    des1: "Value",
    rec: `${totalRecommandationsMargin}`,
    rec1: "Instances",
    icon: QueryStatsIcon,
    src: img1,
    children: [
      {
        id: 1,
        label: "Operational Initiatives",
        dec: `$ ${TotalValueDataRevnuew} Bn`,
        rec: `${TotalValueDataRevnuewLength}`,
        icon: AutoGraphIcon,
        src: img2,
      },
      {
        id: 3,
        label: "Overhead Control",
        dec: `$ ${TotalValueDataOverHead} Bn`,
        rec: `${TotalValueOverHeadLength}`,
        icon: PriceChangeIcon,
        src: img4,
      },
      {
        id: 2,
        label: "Cost Saving",
        dec: `$ ${TotalValueDataCostSaving} Bn`,
        rec: `${TotalValueCostSavingLength}`,
        icon: StackedLineChartIcon,
        src: img3,
      },
     
      {
        id: 4,
        label: "Other",
        dec: `$ ${TotalValueDataOther} Mn`,
        rec: `${TotalValueOverOther}`,
        icon: QueryStatsIcon,
        src: img5,
      },
     
    ],
  }

  
  const ImproveCashFlow =

  {
    id: 0,
    label: "Improve Cash Flow",
    dec: `$ ${(TotalValueDataImproveCashFlow).toFixed(1)} Mn`,
    des1: "Value",
    rec: `${totalRecommandationsMarginCaseFlow}`,
    rec1: "Instances",
    icon: QueryStatsIcon,
    src: img1,
    children: [
      {
        id: 1,
        label: "Accounts Receivable",
        dec: `$ ${(TotalValueDataAccountsReceivable).toFixed(1)} Mn`,
        rec: `${TotalValueDataAccountsReceivableLength}`,
        icon: AutoGraphIcon,
        src: img2,
      },
      {
        id: 2,
        label: "Accounts Payable",
        dec: `$ ${(TotalValueDataAccountsPayable).toFixed(1)} Mn`,
        rec: `${TotalValueDataAccountsPayableLength}`,
        icon: StackedLineChartIcon,
        src: img3,
      },
      {
        id: 3,
        label: "Inventory",
        dec: `$ ${(TotalValueInventory).toFixed(1)} Mn`,
        rec: `${TotalValueInventorydLength}`,
        icon: StackedLineChartIcon,
        src: img3,
      }
    ],
  }

  const ImproveProcess=

  {
    id: 0,
    label: "Process Optimizations",
    dec: "$ 20 Mn",
    des1: "Value",
    rec: "60",
    rec1: "Instances",
    icon: QueryStatsIcon,
    src: img1,
    children: [
      {
        id: 1,
        label: "Revenue Growth",
        dec: "$ 20 Mn",
        rec: "5",
        icon: AutoGraphIcon,
        src: img2,
      },
      {
        id: 2,
        label: "Cost Savings",
        dec: "$ 20 Mn",
        rec: "20",
        icon: StackedLineChartIcon,
        src: img3,
      },
      {
        id: 3,
        label: "Overhead Control​",
        dec: "$ 20 Mn",
        rec: "25",
        icon: PriceChangeIcon,
        src: img4,
      },
      {
        id: 4,
        label: "Other Initiatives​",
        dec: "$ 20 Mn",
        rec: "10",
        icon: QueryStatsIcon,
        src: img5,
      },
    ],
  }

  const Default=

  {
    id: 0,
    label: name,
    dec: "$ 20 Mn",
    des1: "Value",
    rec: "60",
    rec1: "Instances",
    icon: QueryStatsIcon,
    src: img1,
    children: [
      {
        id: 1,
        label: "Revenue Growth",
        dec: "$ 20 Mn",
        rec: "5",
        icon: AutoGraphIcon,
        src: img2,
      },
      {
        id: 2,
        label: "Cost Savings",
        dec: "$ 20 Mn",
        rec: "20",
        icon: StackedLineChartIcon,
        src: img3,
      },
      {
        id: 3,
        label: "Overhead Control​",
        dec: "$ 20 Mn",
        rec: "25",
        icon: PriceChangeIcon,
        src: img4,
      },
      {
        id: 4,
        label: "Other Initiatives​",
        dec: "$ 20 Mn",
        rec: "10",
        icon: QueryStatsIcon,
        src: img5,
      },
    ],
  }

  

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [horizontal] = useState(true);
  const [collapsable] = useState(true);
  const [expandAll] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();



  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  });

  const handleArrowClick = (nodeData) => {
    setSelectedNode(nodeData);
    setSelectedId(nodeData.id);
    handleNodeClick(nodeData);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    localStorage.setItem("activeItem", null);
  }, []);

  
  const toggleNode = (nodeId, node) => {
    if (node.id === nodeId) {
      return {
        ...node,
        expanded: !node.expanded,
        children: node.children?.map(child => ({
          ...child,
          expanded: nodeId === 1 ? true : false,
        }))
      };
    }

    if (node.children) {
      return {
        ...node,
        children: node.children.map(child => toggleNode(nodeId, child)),
      };
    }

    return node;
  };

  const handleNodeClick = (node) => {
    setData(prevData => toggleNode(node, prevData));
  };

  useEffect(()=>{
    if(name === 'Improve Margin'){
      setData(ImproveMargins)
    }
    else if(name === 'Cash Improvement'){
      setData(ImproveCashFlow)
    }
    else if(name === 'Process Optimizations'){
      setData(ImproveProcess)
    }
    else{
      setData(Default)
    }
  },[name])

  
  console.log(selectedNode)

  return (
    <div className="cfo-graph-container-flow flowChart">
      <span
        onClick={handleGoBack}
        style={{
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px",
          cursor: "pointer",
          paddingTop: "10px",
          paddingBottom: "10px"
        }}
      >
        <a style={{ fontWeight: "600" }} href={'/'}>Home</a> /  <span style={{ fontWeight: "600" }}>{name}</span>
      </span>
      <div>
        <div
          style={{
            display: "grid",
            justifyContent: "space-between",
            paddingRight: "10px",
            gridTemplateColumns: "1fr 1fr"
          }}
          className="main_flow"
        >
          {loading ? (
            <div style={{ padding: "3rem" }}>
              <Skeleton height={150} width={400} count={1} />
            </div>
          ) : (
            <OrgTree
              data={data}
              horizontal={horizontal}
              collapsable={collapsable}
              expandAll={false}
              renderContent={(data) => (
                <>
                  <div className={`w-80 p-1 border bg-gradient-to-r to-pink-50 via-pink-50 from-white node-content ${selectedNode && selectedNode.id && selectedNode.id === data.id ? "ActveNode" : ''}`} onClick={() => handleArrowClick(data)} >
                    <div className="flex items-center">
                      <div className="flex flex-col items-center justify-center w-1/2 space-y-2">
                        <div className="flex items-center justify-center w-12 h-12">
                          <span><img src={data.src} width={40} alt="icon" /></span>
                        </div>
                        <h6 style={{ fontSize: "22px" }} className="text-lg font-semibold text-gray-800 text-center">
                          {data.label}
                        </h6>
                      </div>

                      <div className="h-20 border-l border-gray-300 ml-3"></div>

                      <div style={{ textAlign: "center" }} className="flex flex-col justify-center w-1/2 pl-4">
                        <div style={{ paddingTop: '20px' }}>
                          <span style={{ fontSize: "26px", paddingBottom: "5px", display: "block",color:"#F42EBF" }} className="text-blue-500 text-xl font-bold">
                            $ <CountUp start={0} end={parseInt(data.dec.replace(/\D/g, " "), 10)} duration={2} separator="," /> {data.id === 0 ? 'Mn' : "Mn"}
                          </span>
                          <p className="text-sm font-medium text-gray-500">Value Creation</p>
                        </div>
                        <span style={{ paddingBottom: "20px" }} className="mt-2 text-sm text-gray-500">
                          <span style={{ fontSize: "18px" }}>
                            <CountUp start={0} end={parseInt(data.rec, 10)} duration={2} separator="," />
                          </span> Recommendations
                        </span>
                      </div>
                    </div>

                    {data.id !== 0 && (
                      <div
                      className={selectedId === data.id ?'':'org-tree-node-btn'}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleArrowClick(data);
                        }}
                      >
                        {selectedId === data.id ? <FaMinus className="bg-[#1453A0] text-white rounded-full text-lg absolute top-[45%] -right-2" /> : ''}
                      </div>
                    )}
                  </div>
                </>
              )}
            />
          )}

          {selectedNode && selectedNode.id !==0 &&(
            <div  className="summary">
              {selectedNode && <DetailsSummary data={selectedNode} />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlowChart;